<template>
  <div class="life-area-calendar">

    <h1>DELME</h1>

    <calendar-top-bar
      ref="calendarTopBar"
      :config="calendar_config">
      <template slot="left">
      </template>
    </calendar-top-bar>

    <full-calendar
      ref="calendar"
      :events="flattened_calendar_events"
      :config="calendar_config"
      :editable="calendar_config.editable"
      :selectable="calendar_config.selectable"
      ></full-calendar>
      <!-- @view-render="onTimeslotRender"
      @event-selected="onTimeslotEventSelect"
      @event-resize="onTimeslotEventResize"
      @event-drop="onTimeslotEventResize"
      @event-created="onTimeslotEventCreate" -->
    <br />

  </div>
</template>

<script>
import { FullCalendar } from 'vue-full-calendar'
import $ from 'jquery'
import CalendarTopBar from '@/components/CalendarPage/Elements/CalendarTopBar'

export default {
  data: () => ({
    flattened_calendar_events: [], // HACK
    modal_data: {},
    calendar_config: { // TODO: Object.assign({}, default, user_settings)
      defaultView: 'agendaWeek',
      visibleRange: {
        start: '2018-11-17',
        end: '2018-11-20'
      },
      allDaySlot: false, // TODO: Disable as long as everything is implmented
      columnHeader: true,
      firstDay: 1,
      editable: true,
      selectable: true,
      nowIndicator: true,
      minTime: "05:00:00",
      maxTime: "22:00:00",
      themeSystem: 'bootstrap4',
      header: false, /*{ left: '', center: '', right: '' },*/
      now: Date.now(),
      businessHours: {
        // days of week. an array of zero-based day of week integers (0=Sunday)
        dow: [ 1, 2, 3, 4, 5 ], // Monday - Friday
        start: '8:00',
        end: '18:00',
      },
      columnHeaderHtml: null,
      height: 700,
    },
    day_has_conflict: { // TODO: read data from getter as soon as hasConflict is implemented
      '20181113': true,
      '20181118': true,
    }
  }),
  watch: {
    $route (to, from) {
      /* After a route update the calendar needs a refresh! */
      // TODO: only refresh if to is current view
      console.log('***** refresh calendar 2 *****');
      if ( to.path === '/timeslot' ) {
        this.$nextTick(() => {
          /* 'render' does not work, this WORKAROUND does for some reason */
          $(this.$refs.calendar.$el).fullCalendar('prev');
          $(this.$refs.calendar.$el).fullCalendar('next');
          $(this.$refs.calendar.$el).fullCalendar('today');
          $(this.$refs.calendar.$el).fullCalendar('render');
        })
      }
    }
  },
  mounted() {
    /* Update on load */
    // this.triggerCalendarEvent('today');

    /* Display conflict  */
    this.columnHeaderHtml = (mom) => {
      let key = mom.format('YYYYMMDD')
      let hasConflict = this.day_has_conflict[ key ] || false;
      return `
        <div>
          ${mom.format('ddd M/D')}
          ${hasConflict ? '<span style="color:red; font-weight: bold;">!!!</span>' : ''}
        </div>
      `;
    };
    const calendarElement = $(this.$refs.calendar.$el);
    calendarElement.fullCalendar('option', 'columnHeaderHtml', this.columnHeaderHtml);
    // TODO: Maybe this needs an update as soon as day_has_conflict is changed

    /* Add event listener that listens to resizing of the browser window */
    window.addEventListener('resize', () => {
      /* TODO: Should be in TimeslotPage.vue */
      if ( this.$route.name === 'timeslot' ) {
        this.fitCalendarToPage();
      }
    });
    this.fitCalendarToPage()
  },
  computed: {
  },
  methods: {
    fitCalendarToPage() {
      this.calendar_config.height = window.innerHeight - 45 - 400 - 165;
      const calendarElement = $(this.$refs.calendar.$el);
      calendarElement.fullCalendar('option', 'height', this.calendar_config.height);
    },
  },
  components: {
    FullCalendar,
    CalendarTopBar,
  },
}
</script>

<style>
/* Style tabs */
.life-area-calendar .el-tabs--border-card > .el-tabs__content {
  padding: 0;
}
.life-area-calendar .el-tabs--left .el-tabs__item.is-left {
  text-align: inherit;
}
.life-area-calendar .el-tabs--left.el-tabs--border-card .el-tabs__item.is-left {
  width: 300px;
}
/* Fix scroll bug */
.life-area-calendar .el-tabs--left .el-tabs__nav-wrap.is-left.is-scrollable {
  padding: inherit;
}
.life-area-calendar .el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-prev,
.life-area-calendar .el-tabs--left .el-tabs__nav-wrap.is-left > .el-tabs__nav-next {
 display: none;
}
.life-area-calendar .el-tabs--left .el-tabs__nav-scroll {
  overflow-y: scroll;
}
.blue {
  background: #13b4ff;
}
.purple {
  background: #ab3fdd;
}
.wine {
  background: #ae163e;
}
</style>
